import React, { Component } from "react";

import { Card } from "components/Card/Card.jsx";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Table,
    Modal
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { connect } from "react-redux";
import { addNewService, removeService } from '../../redux/actions'
import { NotificationManager } from 'react-notifications';
import { PersianNumber } from '@thg303/react-persian'

const mapStateToProps = (state) => {
    return {
        services: state.services
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addNewService: (service) => dispatch(addNewService(service)),
        removeService: (service) => dispatch(removeService(service))
    }
}

class Services extends Component {
    constructor(props) {
        super(props);
        this.state = {
            service: {
                id: -1,
                price: 0,
                name: '',
            },
            show: false
        }

        this.changeServiceName = this.changeServiceName.bind(this);
        this.changeServicePrice = this.changeServicePrice.bind(this);

        this.addNewServiceBtn = this.addNewServiceBtn.bind(this);
        this.removeService = this.removeService.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.validateServiceData = this.validateServiceData.bind(this);
    }

    handleHide() {
        this.setState({ show: false });
        this.setState({ service: { name: '', price: 0 } })
    }

    handleRemove() {
        this.props.removeService(this.state.service);
        NotificationManager.success("انجام شد", "آدرس با موفقیت حذف شد");
        this.handleHide();
    }

    removeService(prop) {
        this.setState({ service: prop });
        this.setState({ show: true });
    }

    changeServicePrice(e) {
        this.setState({ service: { ...this.state.service, price: e.target.value } });
    }

    changeServiceName(e) {
        this.setState({ service: { ...this.state.service, name: e.target.value } });
    }


    addNewServiceBtn(e) {
        e.preventDefault();
        if (this.validateServiceData()) {
            const newService = { name: this.state.service.name, price: this.state.service.price, id: this.props.services.length + 1 };
            this.props.addNewService(newService);
            this.name.value = '';
            this.price.value = 0;
            this.setState({ service: { name: '', price: 0, id: 0 } })
            NotificationManager.success("خدمات جدید افزوده شد", "انجام شد");
        }
    }

    validateServiceData() {
        if (this.state.service.name.length <= 0) {
            NotificationManager.error("لطفا یک نام برای خدمات وارد کنید", "خطا");
            return false;
        }
        else if (this.state.service.price <= 0) {
            NotificationManager.error("لطفا قیمت را وارد کنید", "خطا");
            return false;
        }
        return true;
    }



    componentWillMount() {
        console.log("this is log component");
    }

    render() {
        return (
            <Grid fluid style={{ marginTop: '30px' }}>
                <Row >
                    <Col md={12}>
                        <Card
                            title="خدمات"
                            content={
                                <div>
                                    <form>
                                        <Row >

                                            
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>نام</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        // value={this.state.customer.lastName}
                                                        bsClass="form-control"
                                                        placeholder="نام"
                                                        inputRef={(ref) => { this.name = ref }}
                                                        defaultValue={this.state.service.name}
                                                        onChange={this.changeServiceName}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>قیمت واحد</ControlLabel>
                                                    <FormControl
                                                        type="number"
                                                        // value={this.state.customer.lastName}
                                                        bsClass="form-control"
                                                        placeholder="قیمت واحد"
                                                        onFocus={() => this.price.value = ""}
                                                        inputRef={(ref) => { this.price = ref }}
                                                        defaultValue={this.state.service.price}
                                                        onChange={this.changeServicePrice}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Button bsStyle="info" onClick={this.addNewServiceBtn} pullRight fill type="submit">
                                            اضافه کردن
                                    </Button>
                                        <div className="clearfix" />
                                        <hr />
                                    </form>
                                    <Table striped hover >
                                        <thead>
                                            <tr>
                                                <th className="text-right">
                                                    شماره
                                                </th>
                                                <th className="text-right">
                                                    نام
                                            </th>
                                                <th className="text-right">
                                                    قیمت واحد
                                            </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.services.map((prop, key) => {
                                                return (
                                                    <tr style={{ "cursor": "pointer" }} key={key} onClick={() => this.removeService(prop)}>
                                                        <td><PersianNumber>{key + 1}</PersianNumber></td>
                                                        <td>{prop.name}</td>
                                                        <td><PersianNumber>{prop.price}</PersianNumber></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            }
                        />
                    </Col>

                    <Modal
                        show={this.state.show}
                        onHide={this.handleHide}
                        container={this}
                        aria-labelledby="contained-modal-title"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">
                                حذف سرویس
                        </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            آیا میخواهید  سرویس انتخابی را حذف کنید ؟
                    </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.handleHide}>بستن</Button>
                            <Button bsStyle="danger" onClick={this.handleRemove}>حذف</Button>
                        </Modal.Footer>
                    </Modal>

                </Row>
            </Grid>
        );
    }
}

const ServicesConnect = connect(mapStateToProps, mapDispatchToProps)(Services);

export default ServicesConnect;